import React, { useState, useEffect } from 'react';
import Header from '../component/Header';
const API = process.env.REACT_APP_API_URL;
const BulkSend = () => {
    const [devices, setDevices] = useState([]);
    const [deviceId, setDeviceId] = useState('');
    const [numbers, setNumbers] = useState('');
    const [message, setMessage] = useState('');
    const [file, setFile] = useState(null);
    const [sending, setSending] = useState(false);
    const [logs, setLogs] = useState([]);

    const fetchDevices = async () => {
        try {
            const res = await fetch(`${API}/api/devices/connected`);
            const data = await res.json();
            if (Array.isArray(data)) {
                setDevices(data);
                setDeviceId((prev) => prev || (data.length ? data[0].id : ''));
            }
        } catch (e) {
            console.error(e);
        }
    };

    useEffect(() => {
        fetchDevices();
    }, []);

    const uploadFile = async (f) => {
        const dataBase64 = await new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => resolve(String(reader.result).split(',')[1]);
            reader.onerror = reject;
            reader.readAsDataURL(f);
        });

        const res = await fetch(`${API}/api/upload-attachment`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                filename: f.name,
                mimeType: f.type || 'application/octet-stream',
                dataBase64
            })
        });
        const result = await res.json();
        if (!res.ok || !result.success) throw new Error(result.error || 'Upload failed');
        return result.attachmentName;
    };

    const handleSend = async () => {
        if (!deviceId) return alert('Select a connected device');
        if (!message.trim() && !file) return alert('Enter message or attach file');

        const list = numbers.split(/[\n,]+/).map((n) => n.replace(/\D/g, '')).filter((n) => n.length >= 10);
        if (!list.length) return alert('Enter valid phone numbers');

        setSending(true);
        setLogs([`Sending to ${list.length} numbers...`]);

        try {
            let attachmentName = '';
            if (file) {
                setLogs((prev) => ['Uploading file...', ...prev]);
                attachmentName = await uploadFile(file);
            }

            const res = await fetch(`${API}/api/send-bulk`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-api-key': 'my_secret_key_123'
                },
                body: JSON.stringify({
                    deviceId,
                    numbers: list.join(','),
                    message: message.trim(),
                    attachmentName: attachmentName || undefined
                })
            });

            const result = await res.json();
            if (!res.ok || !result.success) {
                setLogs((prev) => [`Failed: ${result.error || 'Error'}`, ...prev]);
                return;
            }

            const newLogs = (result.results || []).map((r) =>
                r.success ? `OK ${r.number}` : `FAIL ${r.number}: ${r.error}`
            );
            setLogs((prev) => [...newLogs, 'Done!', ...prev]);
        } catch (e) {
            setLogs((prev) => [`Error: ${e.message}`, ...prev]);
        } finally {
            setSending(false);
        }
    };

    return (
        <div className="wa-page">
            <style>{`
                .wa-page {
                    min-height: 100%;
                    background: #F8F9FA;
                }

                .main-container {
                    max-width: 1200px;
                    margin: 0 auto;
                    padding: 24px 24px 48px;
                }

                .page-hero {
                    background: #FFFFFF;
                    border: 1px solid #E5E7EB;
                    border-radius: 16px;
                    padding: 22px 26px;
                    margin-bottom: 24px;
                    box-shadow: 0 2px 12px rgba(30, 58, 95, 0.05);
                    display: flex;
                    flex-wrap: wrap;
                    justify-content: space-between;
                    align-items: center;
                    gap: 16px;
                }

                .page-title {
                    font-size: 1.6rem;
                    font-weight: 700;
                    color: #333333;
                    margin-bottom: 4px;
                    display: flex;
                    align-items: center;
                }

                .page-subtitle {
                    color: #7A869A;
                    font-size: 0.9rem;
                    margin: 0;
                }

                .device-count-badge {
                    background: #EAF4FE !important;
                    color: #1A73E8 !important;
                    border: 1px solid #c5ddf5;
                    font-weight: 600;
                    font-size: 0.85rem;
                    padding: 10px 18px !important;
                }

                .compose-grid {
                    display: grid;
                    grid-template-columns: 1fr 360px;
                    gap: 24px;
                    align-items: start;
                }

                .compose-primary {
                    display: flex;
                    flex-direction: column;
                    gap: 20px;
                    min-width: 0;
                }

                .compose-sidebar {
                    display: flex;
                    flex-direction: column;
                    gap: 20px;
                    position: sticky;
                    top: 80px;
                }

                .card-modern {
                    background: #FFFFFF;
                    border-radius: 16px;
                    border: 1px solid #E5E7EB;
                    box-shadow: 0 2px 10px rgba(30, 58, 95, 0.04);
                    transition: box-shadow 0.25s ease;
                    overflow: hidden;
                }

                .card-modern:hover {
                    box-shadow: 0 6px 20px rgba(30, 58, 95, 0.08);
                }

                .card-header-custom {
                    padding: 16px 22px;
                    background: #F0F5FA;
                    border-bottom: 1px solid #E5E7EB;
                    border-left: 4px solid #1A73E8;
                }

                .card-header-custom h6 {
                    color: #333333 !important;
                    font-size: 0.9rem;
                    margin: 0;
                    display: flex;
                    align-items: center;
                }

                .card-body-custom {
                    padding: 22px;
                    background: #FFFFFF;
                }

                .form-label-custom {
                    font-weight: 600;
                    font-size: 0.8rem;
                    color: #333333;
                    letter-spacing: 0.4px;
                    text-transform: uppercase;
                    margin-bottom: 8px;
                    display: block;
                }

                .form-control-custom,
                .device-select {
                    border: 1.5px solid #E5E7EB;
                    border-radius: 12px;
                    padding: 12px 16px;
                    font-size: 14px;
                    background: #F8F9FA;
                    width: 100%;
                    color: #333333;
                    transition: border-color 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;
                }

                .form-control-custom:focus,
                .device-select:focus {
                    border-color: #1A73E8;
                    box-shadow: 0 0 0 3px rgba(26, 115, 232, 0.12);
                    background: #FFFFFF;
                    outline: none;
                }

                .form-control-custom::placeholder {
                    color: #7A869A;
                }

                .form-hint {
                    display: block;
                    margin-top: 8px;
                    font-size: 0.8rem;
                    color: #7A869A;
                }

                .char-badge {
                    background: #F0F5FA !important;
                    color: #7A869A !important;
                    border: 1px solid #E5E7EB;
                    font-weight: 500;
                    font-size: 0.75rem;
                    padding: 6px 12px;
                }

                .file-input-wrap {
                    border: 2px dashed #d1d9e0;
                    border-radius: 14px;
                    padding: 16px;
                    background: #F8F9FA;
                    transition: all 0.2s ease;
                }

                .file-input-wrap:hover {
                    border-color: #1A73E8;
                    background: #EAF4FE;
                }

                .file-input-wrap .form-control {
                    border: none;
                    background: transparent;
                    padding: 0;
                }

                .file-input-wrap .form-control:focus {
                    box-shadow: none;
                }

                .send-panel {
                    background: linear-gradient(180deg, #FFFFFF 0%, #F8FBFF 100%);
                    border: 1px solid #c5ddf5;
                }

                .send-panel-body {
                    padding: 24px 22px;
                }

                .send-panel-title {
                    font-size: 0.95rem;
                    font-weight: 700;
                    color: #333333;
                    margin-bottom: 6px;
                }

                .send-panel-desc {
                    font-size: 0.8rem;
                    color: #7A869A;
                    margin-bottom: 18px;
                }

                .btn-success-custom {
                    background: #3BA949;
                    border: none;
                    border-radius: 14px;
                    padding: 16px 24px;
                    font-weight: 700;
                    font-size: 1rem;
                    color: #FFFFFF;
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                    gap: 8px;
                    width: 100%;
                    transition: all 0.2s ease;
                }

                .btn-success-custom:hover:not(:disabled) {
                    background: #339940;
                    box-shadow: 0 8px 24px rgba(59, 169, 73, 0.35);
                    transform: translateY(-1px);
                }

                .btn-success-custom:disabled {
                    opacity: 0.55;
                    cursor: not-allowed;
                    transform: none;
                }

                .log-card-header {
                    padding: 16px 22px;
                    background: #1E3A5F;
                    color: #FFFFFF;
                }

                .log-card-header h6 {
                    margin: 0;
                    font-size: 0.9rem;
                    display: flex;
                    align-items: center;
                    gap: 8px;
                }

                .wa-log-panel {
                    min-height: 280px;
                    max-height: 420px;
                    overflow: auto;
                    font-family: 'Consolas', 'Courier New', monospace;
                    font-size: 13px;
                    background: #0f2439;
                    color: #4CAF50;
                    padding: 16px;
                    line-height: 1.6;
                }

                .wa-log-panel .log-line {
                    padding: 4px 0;
                    border-bottom: 1px solid rgba(255, 255, 255, 0.06);
                }

                .wa-log-panel .log-line:last-child {
                    border-bottom: none;
                }

                .wa-log-panel .log-empty {
                    color: #7A869A;
                    font-style: italic;
                }

                .wa-log-panel .log-fail {
                    color: #f87171;
                }

                .wa-log-panel .log-ok {
                    color: #4ade80;
                }

                .ui-icon {
                    color: #1A73E8;
                    margin-right: 6px;
                }

                .log-header-icon {
                    color: #4CAF50;
                }

                @media (max-width: 991px) {
                    .compose-grid {
                        grid-template-columns: 1fr;
                    }

                    .compose-sidebar {
                        position: static;
                    }
                }

                @media (max-width: 768px) {
                    .main-container { padding: 16px 16px 32px; }
                    .page-hero { padding: 18px; }
                    .page-title { font-size: 1.3rem; }
                    .card-body-custom { padding: 16px; }
                    .card-header-custom { padding: 14px 16px; }
                    .wa-log-panel { min-height: 220px; }
                }

                @media (max-width: 576px) {
                    .page-title { font-size: 1.15rem; }
                    .btn-success-custom { font-size: 0.9rem; padding: 14px 18px; }
                }
            `}</style>

            <Header title="Bulk Send" />

            <div className="main-container">
                <div className="page-hero">
                    <div>
                        <h1 className="page-title">
                            <i className="bi bi-broadcast ui-icon" aria-hidden="true" /> Bulk Send
                        </h1>
                        <p className="page-subtitle">Send messages to multiple contacts at once</p>
                    </div>
                    <span className="badge device-count-badge rounded-pill">
                        <i className="bi bi-phone me-1" aria-hidden="true" /> {devices.length} Device{devices.length !== 1 ? 's' : ''} Connected
                    </span>
                </div>

                <div className="compose-grid">
                    <div className="compose-primary">

                        <div className="card-modern">
                            <div className="card-header-custom">
                                <h6 className="fw-bold"><i className="bi bi-phone ui-icon" aria-hidden="true" /> Device</h6>
                            </div>
                            <div className="card-body-custom">
                                <label className="form-label-custom">Select Device</label>
                                <select className="device-select" value={deviceId} onChange={(e) => setDeviceId(e.target.value)} disabled={sending}>
                                    <option value="">Select device</option>
                                    {devices.map((d) => (
                                        <option key={d.id} value={d.id}>{d.name}</option>
                                    ))}
                                </select>
                            </div>
                        </div>

                        <div className="card-modern">
                            <div className="card-header-custom">
                                <h6 className="fw-bold"><i className="bi bi-people ui-icon" aria-hidden="true" /> Recipients</h6>
                            </div>
                            <div className="card-body-custom">
                                <label className="form-label-custom">Phone Numbers</label>
                                <textarea
                                    className="form-control-custom"
                                    rows="5"
                                    placeholder="9876543210&#10;9876543211&#10;9876543212"
                                    value={numbers}
                                    onChange={(e) => setNumbers(e.target.value)}
                                    disabled={sending}
                                    style={{ resize: 'vertical' }}
                                />
                                <small className="form-hint">Enter one number per line, or separate with commas</small>
                            </div>
                        </div>

                        <div className="card-modern">
                            <div className="card-header-custom">
                                <h6 className="fw-bold"><i className="bi bi-pencil-square ui-icon" aria-hidden="true" /> Message</h6>
                            </div>
                            <div className="card-body-custom">
                                <label className="form-label-custom">Message Text</label>
                                <textarea
                                    className="form-control-custom"
                                    rows="4"
                                    placeholder="Type your bulk message here..."
                                    value={message}
                                    onChange={(e) => setMessage(e.target.value)}
                                    disabled={sending}
                                    style={{ resize: 'vertical' }}
                                />
                                <div className="mt-3">
                                    <span className="badge char-badge rounded-pill">{message.length} characters</span>
                                </div>
                            </div>
                        </div>

                        <div className="card-modern">
                            <div className="card-header-custom">
                                <h6 className="fw-bold"><i className="bi bi-paperclip ui-icon" aria-hidden="true" /> Attachment</h6>
                            </div>
                            <div className="card-body-custom">
                                <label className="form-label-custom">File (optional)</label>
                                <div className="file-input-wrap">
                                    <input
                                        type="file"
                                        className="form-control"
                                        onChange={(e) => setFile(e.target.files?.[0] || null)}
                                        disabled={sending}
                                    />
                                </div>
                                {file && (
                                    <small className="form-hint">
                                        <i className="bi bi-file-earmark-check text-success me-1" aria-hidden="true" />
                                        Selected: {file.name}
                                    </small>
                                )}
                            </div>
                        </div>

                    </div>

                    <div className="compose-sidebar">

                        <div className="card-modern send-panel">
                            <div className="send-panel-body">
                                <div className="send-panel-title">Ready to send?</div>
                                <p className="send-panel-desc">Review numbers and message, then start bulk send.</p>
                                <button
                                    className="btn-success-custom"
                                    onClick={handleSend}
                                    disabled={sending || !devices.length}
                                >
                                    {sending ? (
                                        <>
                                            <span className="spinner-border spinner-border-sm" />
                                            Sending...
                                        </>
                                    ) : (
                                        <>
                                            <i className="bi bi-broadcast" aria-hidden="true" /> Start Bulk Send
                                        </>
                                    )}
                                </button>
                            </div>
                        </div>

                        <div className="card-modern">
                            <div className="log-card-header">
                                <h6 className="fw-bold">
                                    <i className="bi bi-terminal log-header-icon" aria-hidden="true" /> Activity Log
                                </h6>
                            </div>
                            <div className="wa-log-panel">
                                {logs.length ? logs.map((log, i) => (
                                    <div
                                        key={i}
                                        className={`log-line ${log.startsWith('FAIL') || log.startsWith('Failed') || log.startsWith('Error') ? 'log-fail' : log.startsWith('OK') ? 'log-ok' : ''}`}
                                    >
                                        {log}
                                    </div>
                                )) : (
                                    <div className="log-empty">Ready...</div>
                                )}
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    );
};

export default BulkSend;
